import CTAServiceSection from "./CTAServiceSection";
import Noise from "../../Images/noise.png";
import BGCTA from "../../Images/service-section-cta-top.jpg";
import { useNavigate } from "react-router-dom";

const WhyChooseSemars = ({ backgroundImage }) => {
  const navigate = useNavigate();

  const handleGetInTouch = () => {
    navigate("/contact");
  };
  const features = [
    {
      number: "01",
      title: "Led by Experience",
      description:
        " Mr. Sabeel Sajid brings 20+ years of global consulting, defense, investment, and diplomatic exposure to every engagement. ",
    },
    {
      number: "02",
      title: "Comprehensive Advisory",
      description:
        "From legal structuring to post-launch growth, we walk with you through the full lifecycle. ",
    },
    {
      number: "03",
      title: "KSA Focused, Globally Connected",
      description:
        " With strong ties to Saudi royal families, regulators, and decision-makers, we open doors that others can’t. ",
    },
    {
      number: "04",
      title: "Track Record of Results:",
      description:
        "Our work has helped companies scale, win deals, and build trust in KSA’s complex regulatory landscape. ",
    },
    {
      number: "05",
      title: " Personalized Strategy",
      description:
        " Each client receives a customized roadmap, developed with local realities and future ambitions in mind. ",
    },
    {
      number: "06",
      title: "Market entry expertise",
      description: "Seamless guidance for entering Saudi market",
    },
    {
      number: "07",
      title: "Expansion support",
      description: "Strategic assistance for growing operations",
    },
    {
      number: "08",
      title: "Compliance assurance",
      description: "Ensuring adherence to local regulations",
    },
  ];

  return (
    <section className="relative z-50">
      <div className="pt-20 mx-6" data-aos="fade-up">
        <div className="max-w-7xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Why Choose Semars?
            </h2>
          </div>

          {/* Main Content Container */}
          <div
            className="rounded-t-3xl overflow-hidden shadow-2xl"
            style={{ backgroundColor: "#A68B5B" }}
          >
            <div className="flex flex-col lg:flex-row min-h-[600px]">
              {/* Left Side - Image and CTA */}
              <div className="lg:w-1/2 relative">
                <div
                  className="h-full min-h-[400px] lg:min-h-[600px] relative"
                  style={{
                    backgroundImage: BGCTA
                      ? `url(${BGCTA})`
                      : "linear-gradient(135deg, #ff6b6b, #4ecdc4)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  {/* Overlay */}
                  <div className="absolute inset-0 bg-black bg-opacity-10"></div>

                  {/* Content */}
                  <div className="absolute inset-0 flex flex-col justify-end mb-0 md:mb-[15%] items-center text-white p-4 md:p-8 text-center">
                    <p className="text-lg md:text-xl mb-8 max-w-md leading-relaxed">
                      Ready to unlock opportunities in Saudi Arabia's dynamic
                      market? Partner with Semars for expert guidance, strategic
                      insights, and proven results that drive your business
                      forward in the Kingdom.
                    </p>

                    <button
                      className="px-8 py-3 bg-white text-gray-800 rounded-full font-semibold hover:bg-gray-100 transition-all duration-300 transform hover:scale-105"
                      onClick={handleGetInTouch}
                    >
                      Get started
                    </button>
                  </div>
                </div>
              </div>

              {/* Right Side - Features Grid */}
              <div
                className="lg:w-1/2"
                style={{
                  background:
                    "linear-gradient(to bottom, #A38653 0%,  #D9C196 100%)",
                }}
              >
                <div
                  className="p-8 md:p-12"
                  style={{
                    backgroundImage: `url(${Noise})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 h-full">
                    {features.map((feature) => (
                      <div key={feature.number} className="text-white">
                        <div className="mb-3">
                          <span className="text-2xl font-bold opacity-70">
                            {feature.number}
                          </span>
                        </div>
                        <h3 className="text-lg font-semibold mb-2">
                          {feature.title}
                        </h3>
                        <p className="text-sm opacity-80 leading-relaxed">
                          {feature.description}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CTAServiceSection />
    </section>
  );
};

export default WhyChooseSemars;
